import React from 'react';
import './Services.styles.scss';
import { Link } from 'react-router-dom';
import { FiArrowUpRight } from 'react-icons/fi';

function ServiceHeadingLink({ to, children, id }) {
  return (
    <h3 className="main-content-header" id={id}>
      <Link className="service-heading-link" to={to}>
        <span className="service-heading-label">{children}</span>
        <span className="service-heading-icon" aria-hidden="true">
          <FiArrowUpRight />
        </span>
      </Link>
    </h3>
  );
}

export function Services() {
  return (
    <article className="services-article">
      <h2 className="seo-heading">Zakres usług prawnych - Radca Prawny Wrocław</h2>
      
      <ServiceHeadingLink to="/uslugi/odszkodowania" id="odszkodowania">
        odszkodowania
      </ServiceHeadingLink>
      <div className="main-content-text">
        <p>Pomagam uzyskać odszkodowanie indywidualnym klientom. </p>
        <p>
          Formułuję roszczenia odszkodowawcze za szkody <b>na&nbsp;mieniu</b>{' '}
          (kolizje drogowe, uszkodzenia pojazdu) i&nbsp;<b>na&nbsp;osobie</b>.{' '}
        </p>
        <p>
          Reprezentuję pokrzywdzonych w&nbsp;sprawach o&nbsp;zadośćuczynienie
          za&nbsp; śmierć osoby najbliższej.
        </p>
      </div>
      
      <h3 id="prawo-rodzinne">
        prawo <br />
        rodzinne
      </h3>
      <div className="main-content-text">
        <p>
          Specjalizuję się w sprawach rodzinnych, a&nbsp;w&nbsp;szczególności
          prowadzę sprawy o&nbsp;
          <Link className="service-inline-link" to="/uslugi/rozwod-wroclaw">
            rozwód we Wrocławiu
          </Link>
          ,&nbsp;
          <Link className="service-inline-link" to="/uslugi/alimenty-wroclaw">
            alimenty
          </Link>
          ,&nbsp;
          <Link className="service-inline-link" to="/uslugi/podzial-majatku">
            podział majątku
          </Link>{' '}
          oraz&nbsp;
          <Link
            className="service-inline-link"
            to="/uslugi/kontakty-z-dzieckiem"
          >
            kontakty z&nbsp;dzieckiem
          </Link>
          . Pomagam również w&nbsp;sprawach związanych z&nbsp;wykonywaniem
          władzy rodzicielskiej.
        </p>
      </div>
      
      <ServiceHeadingLink
        to="/uslugi/kredyty-frankowe"
        id="kredyty-frankowe"
      >
        kredyty
        <br /> we frankach
      </ServiceHeadingLink>
      <div className="main-content-text">
        <p>Kredyty frankowe to moja specjalność.</p>
        <p>
          Frankowicze i&nbsp;inni kredytobiorcy mający{' '}
          <b>kredyt we frankach szwajcarskich</b>, <b>euro</b> czy{' '}
          <b>jenach japońskich</b> powinni skorzystać z&nbsp;oferty Kancelarii
          w&nbsp;zakresie analizy umowy o&nbsp;kredyt indeksowany/denominowany
          w&nbsp;walucie obcej.
        </p>
        <p>
          Po <b>darmowej</b> i&nbsp;pomyślnej analizie umowy kredytu poprowadzę
          sprawę przeciwko bankowi o&nbsp;unieważnienie umowy kredytu
          i&nbsp;inne roszczenia.
        </p>
      </div>
      
      <ServiceHeadingLink to="/uslugi/prawo-pracy" id="prawo-pracy">
        prawo
        <br />
        pracy
      </ServiceHeadingLink>
      <div className="main-content-text">
        <p>
          W ramach pomocy prawnej z&nbsp;zakresu prawa pracy i&nbsp;ubezpieczeń
          społecznych podejmuję się reprezentacji klientów w&nbsp;sprawach
          o&nbsp;zapłatę, o&nbsp;<b>ustalenie stosunku pracy</b>,
          o&nbsp;przywrócenie do&nbsp;pracy, o&nbsp;<b>odszkodowanie</b>,
          a&nbsp;także o&nbsp;<b>odzyskanie niewypłaconego wynagrodzenia</b>.
        </p>
        <p>
          Reprezentuję klientów w&nbsp;sporach przed{' '}
          <b>Zakładem Ubezpieczeń Społecznych</b>.
        </p>
      </div>
      
      <ServiceHeadingLink to="/uslugi/prawo-karne" id="prawo-karne">
        prawo
        <br />
        karne
      </ServiceHeadingLink>
      <div className="main-content-text">
        <p>
          Podejmę się obrony klienta na etapie postępowania przygotowawczego
          przed <b>Prokuratorem</b>, <b>Policją</b>, jak i&nbsp;w&nbsp;
          <b>postępowaniu karnym sądowym</b>.
        </p>
        <p>
          Pomagam nie tylko podejrzanym o&nbsp;popełnienie czynu zabronionego,
          ale i&nbsp;<b>pokrzywdzonym</b> przestępstwem, którzy chcą dochodzić
          swoich praw.
        </p>
      </div>
      
      <ServiceHeadingLink to="/uslugi/prawo-cywilne" id="prawo-cywilne">
        prawo
        <br />
        cywilne
      </ServiceHeadingLink>
      <div className="main-content-text">
        <p>
          Doradzam w&nbsp;zakresie umów (umowy o&nbsp;<b>świadczenie usług</b>,
          umowy o&nbsp;<b>dzieło</b>, umowy <b>pożyczek</b>, umowy <b>najmu</b>,
          umowy <b>sprzedaży</b> i&nbsp;inne) – sporządzam, rozwiązuję
          i&nbsp;opiniuję umowy oraz&nbsp;przeprowadzam analizy ryzyka prawnego
          w&nbsp;zakresie zawieranych umów.
        </p>
        <p>
          Reprezentuję klientów w&nbsp;sprawach o&nbsp;odszkodowanie
          i&nbsp;zapłatę.
        </p>
      </div>
      <ServiceHeadingLink to="/uslugi/bledy-medyczne" id="bledy-medyczne">
        błędy
        <br />
        medyczne
      </ServiceHeadingLink>
      <div className="main-content-text">
        <p>
          Prowadzę sprawy o&nbsp;odszkodowanie za&nbsp;<b>błędy medyczne</b>,
          a&nbsp;w&nbsp;tym za&nbsp;błędy popełnione w&nbsp;medycynie
          estetycznej, stomatologii i&nbsp;w&nbsp;trakcie innych zabiegów
          przeprowadzonych niezgodne ze&nbsp;sztuką lekarską.
        </p>
      </div>
      
      <ServiceHeadingLink
        to="/uslugi/prawo-spadkowe"
        id="prawo-spadkowe"
      >
        prawo
        <br />
        spadkowe
      </ServiceHeadingLink>
      <div className="main-content-text">
        <p>
          Prowadzę sprawy o&nbsp;<b>zachowek</b>,{' '}
          <b>stwierdzenie nabycia spadku</b>, <b>przyjęcie</b> i&nbsp;
          <b>odrzucenie spadku</b>, a&nbsp;także o&nbsp;
          <b>unieważnienie testamentu</b>.
        </p>
      </div>
      
      <ServiceHeadingLink
        to="/uslugi/roboty-budowlane-i-remonty"
        id="roboty-budowlane"
      >
        roboty budowlane
        <br />i remonty
      </ServiceHeadingLink>
      <div className="main-content-text">
        <p>
          Sporządzam i&nbsp;opiniuję umowy handlowe takie jak&nbsp;umowy
          o&nbsp;dzieło i&nbsp;umowy o&nbsp;roboty budowlane.
        </p>
        <p>
          Prowadzę sprawy sądowe z&nbsp;zakresu <b>robót wykończeniowych</b>,{' '}
          <b>montażowych</b> i&nbsp;<b>naprawczych</b>. Pomagam
          w&nbsp;odzyskaniu odszkodowania za&nbsp;wadliwie wykonany remont
          mieszkania.
        </p>
      </div>
      
      <ServiceHeadingLink
        to="/uslugi/prawo-gospodarcze-i-obsluga-spolek"
        id="obsluga-spolek"
      >
        prawo gospodarcze
        <br />i obsługa spółek
      </ServiceHeadingLink>
      <div className="main-content-text">
        <p>
          Obsługuję <b>spółki prawa handlowego</b> i&nbsp;inne podmioty
          gospodarcze.{' '}
        </p>
        <p>
          Oferuję kompleksową pomoc przy składaniu wniosków i&nbsp;formularzy do
          Krajowego Rejestru Sądowego
          <br /> – zgłaszanie zmian do&nbsp;rejestru (zmiany umowy spółki -
          składu wspólników, wysokości kapitału zakładowego, treści uprawnień
          korporacyjnych), przygotowywanie umów, uchwał i&nbsp;protokołów.
        </p>
      </div>
    </article>
  );
}
